import { useEffect, useState } from "react";
import { feesAPI, academicAPI, studentsAPI } from "../../services/api";
import Modal from "../../components/common/Modal";
import * as XLSX from "xlsx";

const classOptions = ["PLAY GROUP", "NURSERY", "PP-1", "PP-2", "1ST CLASS", "2ND CLASS"];

const defaultTerms = () => ([
    { date: "2026-06-15", amount: "" },
    { date: "2026-09-15", amount: "" },
    { date: "2026-12-15", amount: "" },
]);

const initialFormData = {
    academicYear: "",
    curriculum: "",
    feeCode: "",
    feeName: "",
    feeDescription: "",
    terms: defaultTerms(),
    classes: [],
    discount: "0",
};


const formatDueDate = (isoDate) => {
    if (!isoDate) return "";
    const d = new Date(isoDate + "T00:00:00");
    if (isNaN(d.getTime())) return isoDate;

    const day = d.getDate();
    const month = d.toLocaleDateString("en-US", { month: "long" });
    const suffix =
        day % 10 === 1 && day !== 11 ? "st" :
            day % 10 === 2 && day !== 12 ? "nd" :
                day % 10 === 3 && day !== 13 ? "rd" : "th";

    return `${month} ${day}${suffix}`;
};

const formatCurrency = (num) => `Rs. ${Number(num || 0).toLocaleString("en-IN")}`;

const getTotal = (terms) => terms.reduce((sum, t) => sum + Number(t.amount || 0), 0);

const FeesStrucutre = () => {
    const [feeData, setFeeData] = useState([]);
	const [feeTypes, setFeeTypes] = useState([]);
	const [academicYears, setAcademicYears] = useState([]);
	
	const [classes, setClasses] = useState([]);
	const [loading, setLoading] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showViewModal2, setShowViewModal2] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [editId, setEditId] = useState(null);
    const [feeType, setFeeType] = useState("");
    const [formData, setFormData] = useState(initialFormData);

    const openDeleteModal = (id) => {
        setSelectedId(id);
        setShowViewModal(true);
    };
    useEffect(() => {
    loadData();
}, []);
	const loadData = async () => {

		try {

			setLoading(true);

			const [
				structureRes,
				feeTypeRes,
				academicRes,
				classRes
			] = await Promise.all([

				feesAPI.structures(),
				feesAPI.feeTypes(),
				studentsAPI.academicYears(),   // change according to your API
			         // or curriculumAPI.curriculums()
				studentsAPI.classes()          // change according to your API

			]);

			setFeeData(structureRes.data.results || structureRes.data);
			setFeeTypes(feeTypeRes.data.results || feeTypeRes.data);
			setAcademicYears(academicRes.data.results || academicRes.data);
		
			setClasses(classRes.data.results || classRes.data);

		}
		catch (error) {

			console.log(error);

		}
		finally {

			setLoading(false);

		}

	};
		const handleDelete = () => {
        setFeeData((prev) => prev.filter((item) => item.id !== selectedId));
        setShowViewModal(false);
        setSelectedId(null);
    };

    const openAddModal = () => {
        const nextCode = feeData.length
            ? Math.max(...feeData.map((f) => Number(f.feeCode) || 0)) + 1
            : 1;

        setFormData({ ...initialFormData, terms: defaultTerms(), feeCode: String(nextCode) });
        setFeeType("");
        setEditId(null);
        setShowViewModal2(true);
    };

	const openEditModal = (item) => {
		setFormData({
			academicYear: item.academic_year,
			curriculum: item.curriculum,
			feeCode: item.category_code,
			feeName: item.category_name,
			feeDescription: item.category_description || "",
			terms: item.terms.map((t) => ({
				installment: t.installment,
				date: t.due_date,
				amount: String(t.amount),
			})),
			classes: [String(item.class_obj)],
			discount: String(item.discount || 0),
		});

		setFeeType(String(item.category));
		setEditId(item.id);
		setShowViewModal2(true);
	};

    const closeAddModal = () => {
        setShowViewModal2(false);
        setFormData(initialFormData);
        setFeeType("");
        setEditId(null);
    };

    const handleFormChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleTermChange = (index, field, value) => {
        const updated = [...formData.terms];
        updated[index] = { ...updated[index], [field]: value };
        setFormData({ ...formData, terms: updated });
    };

    const handleClassesChange = (e) => {
        const selected = Array.from(e.target.selectedOptions, (opt) => opt.value);
        setFormData({ ...formData, classes: selected });
    };

	const handleSubmit = async (e) => {
		e.preventDefault();

		try {

			const payload = {
				academic_year: formData.academicYear,
				curriculum: formData.curriculum,
				fee_type: feeType,
				fee_code: formData.feeCode,
				fee_name: formData.feeName,
				fee_description: formData.feeDescription,
				discount: Number(formData.discount),
				classes: formData.classes,
				terms: formData.terms.map(t => ({
					installment: t.installment,
					date: t.date,
					amount: Number(t.amount)
				}))
			};

			if (editId) {
				await feesAPI.updateStructure(editId, payload);
			} else {
				await feesAPI.createStructure(payload);
			}

			await loadData();

			closeAddModal();

		} catch (err) {
			console.log(err);
		}
	};
		const exportToExcel = () => {
        const exportData = feeData.map((item, index) => {
            const total = getTotal(item.terms);
            const afterDiscount = total - Number(item.discount || 0);

            return {
                "S.No": index + 1,
                "Fee Name": item.feeName,
                "Terms and Due Dates": item.terms.map(t => formatDueDate(t.due_date)).join(", "),
                "Academic Year": item.year,
                "Curriculum": item.curriculum,
                "Term Amounts": item.terms.map((t) => formatCurrency(t.amount)).join(", "),
                "Total Amount": formatCurrency(total),
                "Discount": formatCurrency(item.discount),
                "After Discount Amount": formatCurrency(afterDiscount),
                "Applicable Classes": item.classes.join(", "),
            };
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Fee Structure");
        XLSX.writeFile(workbook, "fee-structure.xlsx");
    };

    return (
        <>
            <div className="page-header">
                <div><h2>Fee Strucutre</h2></div>
                <button className="btn btn-primary" onClick={openAddModal}>➕ Add Fee Strucutre</button>
            </div>
            <div className="fee-wrapper">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive fee-table mb-0">
                            <table className="table table-bordered fee-table align-middle mb-0 ">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Fee Name</th>
                                        <th>Terms and Due dates</th>
                                        <th>Academic Year</th>
                                        <th>curriculum</th>
                                        <th>Applicable Classes</th>
                                        <th>Term Amount</th>
                                        <th>Total amount</th>
                                        <th>Discount</th>
                                        <th>After Discount Amount</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {feeData.map((item, index) => {
                                        const total = getTotal(item.terms);
                                        const afterDiscount = total - Number(item.discount || 0);

                                        return (
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>

                                               <td>{item.category_name}</td>

                                                <td>
                                                    {item.terms.map((t, i) => (
													<div key={i}>{formatDueDate(t.due_date)}</div>
												))}
                                                </td>

                                                <td>{item.academic_year_name}</td>
                                                <td>{item.curriculum}</td>
                                                <td>{item.class_name}</td> 
                                                <td>
                                                    {item.terms.map((t, i) => (
                                                        <div key={i}>{formatCurrency(t.amount)}</div>
                                                    ))}
                                                </td>

                                                <td>{formatCurrency(total)}</td>
                                                <td>{formatCurrency(item.discount || 0)}</td>
                                                <td>{formatCurrency(afterDiscount)}</td>



                                                <td className="d-flex">
                                                    <button
                                                        className="btn btn-sm btn-outline-primary me-2"
                                                        onClick={() => openEditModal(item)}
                                                    >
                                                        <i className="bi bi-pencil"></i>
                                                    </button>

                                                    <button
                                                        className="btn btn-danger btn-sm delete-btn"
                                                        onClick={() => openDeleteModal(item.id)}
                                                    >
                                                        <i className="bi bi-trash text-white"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <button className="export-btn" onClick={exportToExcel}>
                            Export to Excel
                        </button>

                        <div className="note-section">
                            <strong> Please note:</strong>
                            <span>
                                {" "}
                                Fee structure cannot edit or delete if any   transactions made with same fee structure
                            </span>
                        </div>

                    </div>
                </div>

            </div>

            <Modal
                show={showViewModal2}
                onClose={closeAddModal}
                title={editId !== null ? "Edit Fee Strucutre" : "Add Fee Strucutre"}
                size="md"
            >
                <form onSubmit={handleSubmit}>

                    <div className="row">
                        <div className="col-md-6 col-6 mb-3">
                            <label className="form-label">
                                Select Academic Year
                            </label>

							<select
								className="form-select"
								name="academicYear"
								value={formData.academicYear}
								onChange={handleFormChange}
							>

							<option value="">Select Academic Year</option>

							{
							academicYears.map(year => (

							<option
							key={year.id}
							value={year.id}
							>
							{year.year}
							</option>

							))
							}

							</select>
                        </div>


                        <div className="col-md-6 col-6 mb-3">
                            <label className="form-label">
                                Curriculum
                            </label>

					<select
						className="form-select"
						name="curriculum"
						value={formData.curriculum}
						onChange={handleFormChange}
					>
						<option value="">-- Select Curriculum --</option>
						<option value="SSC">SSC/State Board</option>
						<option value="CBSE">CBSE</option>
						<option value="ICSE">ICSE</option>
						<option value="NIOS">NIOS</option>
						<option value="IB">IB</option>
					</select>
                        </div>

                        <div className="col-md-12 mb-3">
                            <label className="form-label">
                                Fee Type
                            </label>

							<select
								className="form-select"
								value={feeType}
								onChange={(e) => setFeeType(e.target.value)}
							>
								<option value="">Select Fee Type</option>

								{feeTypes.map(item => (
									<option
										key={item.id}
										value={item.id}
									>
										{item.name}
									</option>
								))}
							</select>
                        </div>
                    </div>
                    {
                      

                        <div className="row">

                            <div className="col-md-6 col-6 mb-3">
                                <label className="form-label">
                                    Fee Code
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="feeCode"
                                    value={formData.feeCode}
                                    onChange={handleFormChange}
                                />
                            </div>


                            <div className="col-md-6 col-6 mb-3">
                                <label className="form-label">
                                    Fee Name
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="feeName"
                                    placeholder="e.g. TUITION FEE"
                                    value={formData.feeName}
                                    onChange={handleFormChange}
                                />
                            </div>


                            <div className="col-md-12 mb-3">
                                <label className="form-label">
                                    Fee Description
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="feeDescription"
                                    value={formData.feeDescription}
                                    onChange={handleFormChange}
                                />
                            </div>


                            <div className="mb-3">

                                <label className="form-label">
                                    Select Terms and Due Dates
                                </label>

                                {formData.terms.map((term, index) => (
                                    <div className="row mb-2" key={index}>

                                        <div className="col-md-4">
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={term.date}
                                                onChange={(e) =>
                                                    handleTermChange(index, "date", e.target.value)
                                                }
                                            />
                                        </div>

                                        <div className="col-md-1 pt-2">
                                            Rs.
                                        </div>

                                        <div className="col-md-4">
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Fee Amount"
                                                value={term.amount}
                                                onChange={(e) =>
                                                    handleTermChange(index, "amount", e.target.value)
                                                }
                                            />
                                        </div>

                                    </div>
                                ))}

                            </div>


                            <div className="mb-3">
                                <label className="form-label">
                                    Discount Amount (Rs.)
                                </label>

                                <input
                                    type="number"
                                    className="form-control"
                                    name="discount"
                                    placeholder="0"
                                    value={formData.discount}
                                    onChange={handleFormChange}
                                />
                            </div>


                            <div className="mb-3">

                                <label className="form-label">
                                    Select Applicable Classes from the list
                                </label>

<select
multiple
className="form-select"
value={formData.classes}
onChange={handleClassesChange}
>

{
classes.map(cls => (

<option
key={cls.id}
value={cls.id}
>

{cls.name}

</option>

))
}

</select>

                            </div>


                        </div>
                    }













                    <div className="mt-4 text-center">

                        <button
                            type="submit"
                            className="btn btn-info text-white me-2 px-4"
                        >
                            {editId !== null ? "Update" : "Submit"}
                        </button>


                        <button
                            type="button"
                            className="btn btn-light border px-4"
                            onClick={closeAddModal}
                        >
                            Cancel
                        </button>

                    </div>

                </form>
            </Modal>

            <Modal
                show={showViewModal}
                onClose={() => setShowViewModal(false)}
                title="Delete Fee Strucutre"
                size="md"
            >
                <div className="container-fluid py-3">

                    <div className="modal-body">
                        <p>
                            Are you sure you want to delete this fee
                            structure?
                        </p>
                    </div>

                    <div className="modal-footer">
                        <button
                            className="btn btn-secondary"
                            onClick={() => setShowViewModal(false)}
                        >
                            Cancel
                        </button>

                        <button
                            className="btn btn-danger"
                            onClick={handleDelete}
                        >
                            OK
                        </button>
                    </div>
                </div>
            </Modal>


        </>
    );
};

export default FeesStrucutre;